import { requestHelpers } from '../../../../../helpers';

export const actions = {
    GET_PROFILE_COMPLETE: 'GET_PROFILE_COMPLETE',
    SET_PROFILE_COMPLETE: "SET_PROFILE_COMPLETE",
    PROFILE_COMPLETE_ERROR: 'PROFILE_COMPLETE_ERROR',
};

export const getProfileComplete = (personId) => {
    return (dispatch) => {
        dispatch({
            type: actions.GET_PROFILE_COMPLETE,
            isProfileCompleteFetching: true,
            isProfileCompleteError: false,
        });

        requestHelpers
            .authenticatedGetRequest(`/profiles/${personId}/percentage-complete`)
            .then((response) => {
                return dispatch({
                    type: actions.SET_PROFILE_COMPLETE,
                    body: response.data,
                    isProfileCompleteFetching: false,
                    isProfileCompleteError: false,
                })
            })
            .catch((error) => {
                console.log('LOG: ERROR', error);
                return dispatch({
                    type: actions.PROFILE_COMPLETE_ERROR,
                    isProfileCompleteFetching: false,
                    isProfileCompleteError: true,
                    error: error.status,
                })
            })
    }
};


// WEBPACK FOOTER //
// src/client/components/site/features/profile/actions/profile-complete.js